'use client';

import { useState } from 'react';
import { setCookieAction } from '~/app/actions/client/set-cookie-action';
import { getCookieAction } from '~/app/actions/client/get-cookie-action';
import { Applicant } from '~/app/layout';
import { cn } from '~/lib/utils';
import { addFavorite, removeFavorite } from '~/app/actions/favorites-action';

interface FavoriteButtonProps {
  jobId: number;
  favorite: boolean;
  currentApplicant: Applicant | null;
}

export function FavoriteButton(props: FavoriteButtonProps) {
  const [isFavorite, setIsFavorite] = useState(props.favorite);

  const handleClick = async () => {
    if (props.currentApplicant) {
      // ログインしている場合はDBで管理
      if (isFavorite) {
        // お気に入り登録済みの場合は削除
        setIsFavorite(false);
        await removeFavorite(props.jobId);
      } else {
        // お気に入り登録未済の場合は追加
        setIsFavorite(true);
        await addFavorite(props.jobId);
      }
    } else {
      // ログインしていない場合はクッキーで管理
      const favorite_job_ids = JSON.parse(
        (await getCookieAction('favorite_job_ids')) || '[]',
      );
      if (isFavorite) {
        setIsFavorite(false);
        setCookieAction({
          key: 'favorite_job_ids',
          value: JSON.stringify(
            favorite_job_ids.filter((id: number) => id !== props.jobId),
          ),
        });
      } else {
        setIsFavorite(true);
        setCookieAction({
          key: 'favorite_job_ids',
          value: JSON.stringify([...favorite_job_ids, props.jobId]),
        });
      }
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={cn(
        'c-button -border-orange -heart-icon -sp-text-sm',
        isFavorite && '-done -solid',
      )}
    >
      お気に入り登録
    </button>
  );
}

export default FavoriteButton;
